const translations = {
    headline: {
        type: 'text',
        defaultValue: 'Blog',
    },
    subheadline: {
        type: 'text',
        defaultValue: 'Znajdź interesujący Cię temat!',
    },
};

export default translations;
